/* @flow */

import { push, replace } from 'react-router-redux'

import type { Action, PollId, RootState } from '../types'

import {
  OLD_LIBRARY_URL,
  LOGIN_URL,
  OLD_LOGIN_URL,
  urlForPollWhereId,
  urlForPollAnalyticsWhereId,
  LIBRARY_URL,
  VERIFY_URL,
} from '../urls'

import { noopAction } from '../stores/noop'

import { parseIntOr } from '../helpers'

export const STATE_KEY = 'routing'

export function selectLocation(state: RootState): Object {
  return state[STATE_KEY].locationBeforeTransitions
}

export function selectQuery(state: RootState): Object {
  return selectLocation(state).query
}

export function goToOldLibrary(): Action {
  return push(OLD_LIBRARY_URL)
}
export function goToLibrary() {
  return window.location.assign(LIBRARY_URL)
}

export function goToVerify() {
  return window.location.assign(VERIFY_URL)
}

export function goToPollWhereId(id: PollId): Action {
  return push(urlForPollWhereId(id.toString()))
}

export function goToPollAnalyticsWhereId(id: PollId): Action {
  return push(urlForPollAnalyticsWhereId(id.toString()))
}

export function goToOldLogin(): Action {
  return push(OLD_LOGIN_URL)
}

export function goToLogin() {
  return window.location.assign(LOGIN_URL)
}

/*
 * returns an action that when dispatched
 * merges an object into the
 * current query parameters in the browser url
 */
export function mergeIntoQuery(location: Object, changes: Object): Action {
  const newLocation = Object.assign({}, location)
  newLocation.query = Object.assign({}, newLocation.query, changes)
  return replace(newLocation)
}

/*
 * returns an action that when dispatched goes to the previous page
 */
export function goToPreviousPage(location: Object): Action {
  const query = location.query
  const page = parseIntOr(query.page, 0)
  const previousPage = page - 1
  if (previousPage >= 0) {
    return mergeIntoQuery(location, { page: previousPage })
  }
  return noopAction()
}

/*
 * returns an action that when dispatched goes to the next page
 */
export function goToNextPage(location: Object): Action {
  const query = location.query
  const page = parseIntOr(query.page, 0)
  return mergeIntoQuery(location, { page: page + 1 })
}

export function updateSearch(location: Object, search: string): Action {
  return mergeIntoQuery(location, {
    search,
    page: 0,
  })
}



// WEBPACK FOOTER //
// ./src/stores/routing.js